const voice = {
  recognition: null,
  listen: false,
  counter: 0,
  textContent: "",

  onlisten: null,
  ondone: null,
  onstart: null,
  onstop: null,
  onerror: null,
  oncounter: null,

  /* METHODS */
  init() {
    if (window.hasOwnProperty('webkitSpeechRecognition')) {
      // this.recognition = new webkitSpeechRecognition();
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)(); //testar
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = "pt-BR";
    } 
  },
  
  start(eventlisten = () => { }, eventdone = () => { }, eventerror = () => { }, eventcounter = () => { }) {
    // console.log('start');
    this.onlisten = eventlisten;
    this.ondone = eventdone;
    this.onerror = eventerror;
    this.oncounter = eventcounter;
    // console.log('start 2');
    
    if (this.recognition) {
      // console.log('start 3');
      // eventBus.$emit("voicetotextstart", false);
      this.listen = true;
      [eventlisten(true)];
      // console.log('start 4');
      this.recognition.start();
      // console.log('start 5');
      // This event happens when you talk in the microphone
      this.recognition.onresult = (event) => {
        // console.log('start 6');

        // console.log('event.resultIndex:', event.resultIndex);
        // console.log('event.results.length:', event.results.length);
        // console.log('event.resultIndex:', event.resultIndex);
        // console.log('event.results[0]:', event.results[0], event.results[0].isFinal);

        this.counter++;
        [eventcounter(this.counter)];
        
        for (let i = event.resultIndex; i < event.results.length; i++) {

          // console.log('event.results[i][0].transcript.trim():',event.results[i][0].transcript.trim());

          if (event.results[i].isFinal) {
            this.counter = 0;
            // Here you can get the string of what you told
            const content = event.results[i][0].transcript.trim();
            //console.log('content:', content);
            this.textContent = content;
            this.listen = false;
            
            [eventlisten(false)];
            [eventdone(content)];
            // [this.ondone(content)];
            this.stop();
          }
        }
      };
    } else {
      //console.log('não foi possível iniciar o reconhecimento de voz');
      [eventerror('não foi possível iniciar o reconhecimento de voz')];
    }
  },
  
  stop(eventstop = () => { }) {
    this.onstop = eventstop;

    if (this.recognition) {
      this.listen = false;
      [this.onlisten(this.listen)];
      this.recognition.stop();
      [this.onstop()];
    } else {
      // console.log('não foi possível iniciar o reconhecimento de voz');
      [this.onerror('não foi possível iniciar o reconhecimento de voz')];      
    }
  }
}

voice.init();

export default voice;